// src/HeartIcon.tsx
import { jsx } from "react/jsx-runtime";
var HeartIcon = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    width: "15",
    height: "13",
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M10.2079 0.791992C8.96734 0.791992 7.85697 1.39516 7.1647 2.32047C6.47243 1.39516 5.36206 0.791992 4.12145 0.791992C2.01723 0.791992 0.310547 2.50553 0.310547 4.62346C0.310547 5.43911 0.440776 6.19306 0.666963 6.89219C1.74992 10.3193 5.08789 12.3687 6.73974 12.9307C6.97278 13.0129 7.35661 13.0129 7.58966 12.9307C9.24151 12.3687 12.5795 10.3193 13.6624 6.89219C13.8886 6.19306 14.0189 5.43911 14.0189 4.62346C14.0189 2.50553 12.3122 0.791992 10.2079 0.791992Z",
        fill: "currentColor"
      }
    )
  }
);

export {
  HeartIcon
};
